import React, { Component } from "react";
import { PATHS } from "../../constant";
import LoginDesc from "./LoginDesc";
import { withCookies } from "react-cookie";
import UserVerification from "./UserVerification";
import LoginFormOtp from "./LoginFormOtp";
import backButton from "../../assets/back-button.png";

class LoginWithOTPWrapper extends Component {
  render() {
    const { cookies, history } = this.props;
    return (
      <React.Fragment>
        <div className="signup user-login">
          <div className="login-register-tabs">
            <button className="login-btn active">Login</button>
            <button
              className="register-btn"
              onClick={() => history.push(PATHS.SIGNUP)}
            >
              Register
            </button>
          </div>

          <div className="register-outer">
            <img
              src={backButton}
              alt="Back"
              className="back-btn"
              onClick={() => history.push(PATHS.LOGIN)}
            />
            <LoginFormOtp cookies={cookies} />
          </div>
          <div className="no-account">
            <LoginDesc
              accountHeading="Don't have an account?"
              buttonText="Register"
              subHeading="Register Now"
              buttonLink="/register"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withCookies(LoginWithOTPWrapper);
